import React, { useState } from 'react';
import { Box } from '@mui/material';
import ExcelMappingConfigList from '../components/ExcelMappingConfigList';
import ExcelMappingConfigForm from '../components/ExcelMappingConfigForm';
import ExcelMappingPreview from '../components/ExcelMappingPreview';
import type { ExcelMappingConfig } from '../api/excelMapping';
// NOTE: remove unused i18n hooks if present

type ViewMode = 'list' | 'create' | 'edit' | 'preview';

const ExcelMappingPage: React.FC = () => {
  const [viewMode, setViewMode] = useState<ViewMode>('list');
  const [selectedConfig, setSelectedConfig] = useState<ExcelMappingConfig | null>(null);

  const handleCreate = () => {
    setSelectedConfig(null);
    setViewMode('create');
  };

  const handleEdit = (config: ExcelMappingConfig) => {
    setSelectedConfig(config);
    setViewMode('edit');
  };

  const handleView = (config: ExcelMappingConfig) => {
    setSelectedConfig(config);
    setViewMode('preview');
  };

  const handleSave = (_config: ExcelMappingConfig) => {
    setSelectedConfig(null);
    setViewMode('list');
  };

  const handleCancel = () => {
    setSelectedConfig(null);
    setViewMode('list');
  };

  const renderContent = () => {
    switch (viewMode) {
      case 'list':
        return (
          <ExcelMappingConfigList
            onEdit={handleEdit}
            onView={handleView}
            onCreate={handleCreate}
          />
        );
      case 'create':
        return (
          <ExcelMappingConfigForm
            onSave={handleSave}
            onCancel={handleCancel}
          />
        );
      case 'edit':
        return (
          <ExcelMappingConfigForm
            config={selectedConfig!}
            onSave={handleSave}
            onCancel={handleCancel}
          />
        );
      case 'preview':
        return (
          <ExcelMappingPreview
            config={selectedConfig!}
            onBack={handleCancel}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      {renderContent()}
    </Box>
  );
};

export default ExcelMappingPage;
